import { Button, Dialog, LinkedinIcon } from '@buffer-mono/popcorn'

import type { Channel } from '../../../../common/types'

import { LinkedInProfileList } from './LinkedInProfileList'
import styles from './LinkedInCapabilities.module.css'

import type { JSX } from 'react'

type LinkedInCapabilitiesContentProps = {
  linkedInProfiles: Channel[]
  onConnectProfile: () => void
  onOpenProfileSettings: (channelId: string) => void
}

export function LinkedInCapabilitiesContent({
  linkedInProfiles,
  onConnectProfile,
  onOpenProfileSettings,
}: LinkedInCapabilitiesContentProps): JSX.Element {
  return (
    <Dialog.Content size="xlarge" className={styles.dialogContent}>
      <Dialog.CloseButton />
      <Dialog.Header className={styles.header}>
        <span className={styles.icon} aria-hidden="true">
          <LinkedinIcon size={32} />
        </span>
        <Dialog.Title>
          Showcase your Buffer capabilities on your LinkedIn Profile
        </Dialog.Title>
        <Dialog.Description>
          Earn capabilities as you use Buffer and let the world know!
        </Dialog.Description>
      </Dialog.Header>

      <Dialog.Body className={styles.body}>
        {linkedInProfiles.length > 0 ? (
          <LinkedInProfileList
            onOpenProfileSettings={onOpenProfileSettings}
            profiles={linkedInProfiles}
          />
        ) : (
          <Button type="button" onClick={onConnectProfile} variant="primary">
            Connect a LinkedIn Profile
          </Button>
        )}
      </Dialog.Body>
    </Dialog.Content>
  )
}
